var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"title":"Messages","icon":"fa-envelope","max-height":_vm.maxHeight,"header-button":"fa-external-link-alt"},on:{"headerButtonClick":function($event){return _vm.$router.push('/messages')}}},[_c('message-thread-list',{attrs:{"side-margins":"-8px","job-id":_vm.jobId,"service-id":_vm.serviceId,"store-threads-locally":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }